<hsg-modal>
  <span class="title">הזן את הסיסמה שקיבלת במסרון SMS</span>
  <div class="body" ngForm #otpForm="ngForm" (ngSubmit)="submit(otpForm)" (keyup.enter)="otpForm.onSubmit()">
    <p>
      שדות בטופס המסומנים בכוכבית הינם שדות חובה
     <span class="asterix">*</span>
      </p>    
    <div class="h-gr h-gr--nowrap">

        <div class="c-column-logo">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 128 128">
            <path d="M46.9,15.7h16.2v3.2H46.9V15.7z"/>
            <path d="M59.4,114.4h-8.7v-5.2h8.7V114.4z"/>
            <path d="M89.7,44.8v-30c0-4.3-3.5-7.8-7.8-7.8H28.5c-4.3,0-7.8,3.5-7.8,7.8v100.5c0,4.3,3.5,7.8,7.8,7.8h53.4
              c4.3,0,7.8-3.5,7.8-7.8v-30h19.6V44.8H89.7z M84.5,106.1v9.2c0,1.4-1.2,2.6-2.6,2.6H28.5c-1.4,0-2.6-1.2-2.6-2.6v-9.2H84.5z
               M84.5,85.3v15.6H25.9V27.1h58.6v17.6H49.6v40.5H84.5z M52.8,49.1l26.7,15.7l26.7-15.7v33H52.8V49.1z M57.1,48h44.6L79.4,61.1
              L57.1,48z M25.9,21.9v-7.2c0-1.4,1.2-2.6,2.6-2.6h53.4c1.4,0,2.6,1.2,2.6,2.6v7.2H25.9z"/>
          </svg>
        </div>

      <div class="h-cl">

        <p>
          מסרון SMS עם סיסמת הכניסה למידע האישי שלך נשלח לטלפון הנייד שלך ברגעים אלה 
        </p>
        <div class="h-gr">
          <div class="h-cl">
            <hsg-field>
              <input type="tel" name="pwOtp" id="pwOtp" hsgInput aria-invalid="false"
              required ngModel #pwOtp="ngModel">
              <label hsgLabel>סיסמה</label>
              <div hsgError *ngIf="pwOtp.invalid && otpForm.submitted">
                <div hsgError *ngIf="pwOtp?.errors?.required && !serverError">
                  לא הוזן סיסמה
                </div>
              </div>
            </hsg-field>
          </div>
        </div>
        <!-- <re-captcha *ngIf="showCaptcha"
        (resolved)="resolvedCaptcha($event)"
        name="captcha"
        required
        ngModel
        #captchaControl="ngModel">
      </re-captcha>
      <div hsgError *ngIf="captchaControl?.errors.required">יש להזין קאפצ'ה</div>
      <div hsgError *ngIf="captchaControl?.invalid">יש להזין קאפצ'ה</div> -->
      <div hsgError *ngIf="serverError">
        {{serverError}}
      </div>
      <br>
       <ngx-invisible-recaptcha *ngIf="showCaptcha" #captchaElem  [hl]="'he'" (ready)="captchaReady()" (success)="captchaSuccess($event)" [type]="'image'" [badge]="'inline'">
      </ngx-invisible-recaptcha>
      </div>
    </div>
  </div>
  <div class="actions">
    <button  [gaManager]="{type:'click',category:this.gaCategory,action:'OTP field presented - try '+this._countTimes,label:this.loginOriginAction}" 
    hsg-button kind="primary" (click)="otpForm.onSubmit()" [disabled]="pending">המשך
      <hsg-spinner *ngIf="pending" class="u-mr-s"></hsg-spinner>
    </button>
  </div>
</hsg-modal>